import styled, { css } from 'styled-components'

type ProfileFilterContentProps = {
  small: boolean
}

export const ProfileFilterContent = styled.div<ProfileFilterContentProps>`
  ${({ theme, small }) => css`
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .form-group {
      margin-right: 8px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;

      label {
        font-size: 14px;
        font-weight: 600;
        color: #4a4a4a;
        display: block;
        letter-spacing: -1px;
        margin-bottom: 5px;
      }

      @media (max-width: ${theme.media.ipad}) {
        margin-bottom: 8px;
      }
    }

    .no-label {
      @media (min-width: ${theme.media.desktop}) {
        margin-top: 20px;
      }
    }

    select {
      background-color: #ffffff;
      min-width: 200px;
    }

    label {
      cursor: default;
    }

    ${!small &&
    css`
      @media (min-width: ${theme.media.desktop}) {
        select:first-child {
          width: 280px;
        }
      }
    `}

    @media (max-width: ${theme.media.ipad}) {
      flex-direction: column;
      .form-group {
        width: 100%;
        margin-right: 0;
      }
    }
  `}
`

export const FilterMobileWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`

export const FilterButton = styled.button`
  ${({ theme }) => css`
    border-radius: 4px;
    border: 2px solid transparent;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 14px;
    padding: 12px 16px;
    max-height: 42px;
    margin-top: 5px;
    display: flex;
    align-items: center;
    transition: ${theme.transition.default};
    cursor: pointer;
    background: ${theme.colors.primary};
    color: ${theme.colors.white};

    @media (max-width: ${theme.media.ipad}) {
      margin-left: 0;
    }

    &:hover {
      background: #a71e26;
    }

    @media (max-width: 1170px) {
      width: 100%;
    }
  `}
`

interface FilterMobileButtonProps {
  align: boolean
}

export const FilterMobileButton = styled.button<FilterMobileButtonProps>`
  ${({ theme, align }) => css`
    padding: 8px 10px;
    border-radius: 4px;
    border: 2px solid transparent;
    transition: ${theme.transition.default};
    background: ${theme.colors.primary};
    color: ${theme.colors.white};
    cursor: pointer;

    display: flex;

    ${!!align &&
    css`
      @media (min-width: 800px) and (max-width: ${theme.media.ipad}) {
        margin-right: 16px;
      }
    `}

    &:hover {
      background: #a71e26;
    }
  `}
`
